import { createCodedError } from '~/common/errors/CodedError';
import { JsonApiErrorResponse } from '~/redux/api/ApiTypes';
import { testIsAxiosError } from '~/redux/api/utils';
import { ServiceRequestConfig } from '~/services/createService';
import { scribyl } from '~/services/serviceInstances';

type DeleteSharepointConfigurationRequest = {
  clientId: string;
};

export async function deleteSharepointConfiguration(
  request: DeleteSharepointConfigurationRequest,
  options: ServiceRequestConfig = {},
): Promise<void> {
  try {
    await scribyl.remove('/integration-config', {
      params: { clientId: request.clientId },
      ...options,
    });
  } catch (error) {
    if (testIsAxiosError<JsonApiErrorResponse>(error) && error.response) {
      const errorResponse = error.response.data.errors?.[0];
      throw createCodedError({
        message: errorResponse?.detail ?? errorResponse?.title,
        statusCode: errorResponse?.status,
        title: errorResponse?.title,
      });
    }
    throw error;
  }
}
